import { useMotionValue, motion, useSpring, useTransform } from "framer-motion";
import React, { useRef } from "react";
import { FiArrowRight } from "react-icons/fi";
import image1 from "src/img/publications/1.png";
import image2 from "src/img/publications/2.png";
import image3 from "src/img/publications/3.png";
import image4 from "src/img/publications/4.png";

export const HoverImageLinks = () => {
  return (
    <section className="p-4 md:p-8">
      <div className="mx-auto max-w-[80rem]">
        <Link
          heading="1. Proceedings of the International e-Conference on Advances in Computer Engineering and Communication Systems "
          subheading="Authors : Ireddi Rakshitha, Thokala Vasisri, Mayaluri Anusha, M. Sucharitha"
          imgSrc={image1}
          href="https://www.atlantis-press.com/proceedings/icacecs-23/125995731"
        />
        <Link
          heading="2. Revolutionizing Solar Generation Data Mining through Advanced Machine Learning Algorithms: Novel Insights and Results "
          subheading="Authors : S.P. Siddique Ibrahim,I. Rakshitha,T. Vasisri,R. Hima Aswitha,,M. Ramachandra Rao,D. Vamsi Krishna "
          imgSrc={image2}
          href="https://ieeexplore.ieee.org/abstract/document/10334112?casa_token=58maOq_1KCAAAAAA:X8SalFAEZI7Jhrce0jiktuA3yvWrC2QFbGqLz-wVlgLuayhQllkI9MxD7iLEux7Tg04K0oqIy9zITBE"
        />
        <Link
          heading="3. Unleashing Machine Wisdom: A Glimpse Into AI-Powered Tsunami Early Warning Systems "
          subheading="Author : Siddique Ibrahim S. P., Ireddi Rakshitha, Uppara Nithin, Lakkakula Namratha, Naga Sai Rahul V., Mohammed Abdul Kareem Shaik "
          imgSrc={image3}
          href="https://www.igi-global.com/chapter/unleashing-machine-wisdom/345862?utm_campaign=shareaholic&utm_medium=linkedin&utm_source=socialnetwork"
        />
        <Link
          heading="4. Anime Visage: Revealing Ingenuity with GAN-Assisted Character Development "
          subheading="Author : I. Rakshitha,Uppara Nithin,Shaik Mohammed Abdul Kareem,V Naga Sai Rahul,Nagendra Panini Challa,Beebi Naseeba "
          imgSrc={image4}
          href="https://ieeexplore.ieee.org/document/10612511"
        />
      </div>
    </section>
  );
};

const Link = ({ heading, imgSrc, subheading, href, subheading1 }) => {
  const ref = useRef(null);

  const x = useMotionValue(0);
  const y = useMotionValue(0);

  const mouseXSpring = useSpring(x);
  const mouseYSpring = useSpring(y);

  const top = useTransform(mouseYSpring, [0.5, -0.5], ["40%", "60%"]);
  const left = useTransform(mouseXSpring, [0.5, -0.5], ["60%", "70%"]);

  const handleMouseMove = (e) => {
    const rect = ref.current.getBoundingClientRect();

    const width = rect.width;
    const height = rect.height;

    const mouseX = e.clientX - rect.left;
    const mouseY = e.clientY - rect.top;

    const xPct = mouseX / width - 0.5;
    const yPct = mouseY / height - 0.5;

    x.set(xPct);
    y.set(yPct);
  };

  return (
    <motion.a
      href={href}
      ref={ref}
      onMouseMove={handleMouseMove}
      initial="initial"
      whileHover="whileHover"
      className="group relative flex items-center justify-between border-b-2 border-neutral-700 py-4 transition-colors duration-500 hover:border-neutral-50 md:py-8"
    >
      <div>
        <motion.span
          variants={{
            initial: { x: 0 },
            whileHover: { x: -16 },
          }}
          transition={{
            type: "spring",
            staggerChildren: 0.075,
            delayChildren: 0.25,
          }}
          className="relative z-10 block text-lg text-left font-carmen font-bold text-neutral-200 transition-colors duration-500 group-hover:text-neutral-50 md:text-xl"
        >
          {heading.split().map((l, i) => (
            <motion.span
              variants={{
                initial: { x: 0 },
                whileHover: { x: 16 },
              }}
              transition={{ type: "spring" }}
              className="inline-block"
              key={i}
            >
              {l}
            </motion.span>
          ))}
        </motion.span>
        <span className="relative z-10 mt-4 block font-varelaround text-left text-base text-neutral-300 transition-colors duration-500 group-hover:text-neutral-50">
          {subheading}
        </span>

        <span className="relative z-10 mt-1 font-varelaround block text-left text-base text-neutral-300 transition-colors duration-500 group-hover:text-neutral-50">
          {subheading1}
        </span>
      </div>

      <motion.img
        style={{
          top,
          left,
          translateX: "-50%",
          translateY: "-50%",
        }}
        variants={{
          initial: { scale: 0, rotate: "-12.5deg" },
          whileHover: { scale: 1, rotate: "12.5deg" },
        }}
        transition={{ type: "spring" }}
        src={imgSrc}
        className="absolute z-10 h-24 w-32 rounded-xl object-cover md:h-48 md:w-64"
        alt={`Image representing a link for ${heading}`}
      />

      <motion.div
        variants={{
          initial: {
            x: "25%",
            opacity: 0,
          },
          whileHover: {
            x: "0%",
            opacity: 1,
          },
        }}
        transition={{ type: "spring" }}
        className="relative z-10 p-4"
      >
        <FiArrowRight className="text-5xl text-neutral-50" />
      </motion.div>
    </motion.a>
  );
};

export default HoverImageLinks;